import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Company } from 'src/secret-menu/hooks/useCompanies';

type UpdateFinioFirmNameInput = {
  finioFirmName: string | null;
  confirmSharedFeedIdentifiers?: boolean;
};

export const useUpdateFinioFirmName = (companyId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useMutation<{ data: Company }, Error, UpdateFinioFirmNameInput>({
    mutationFn: (input: UpdateFinioFirmNameInput) =>
      api.put<Company>(`admin/companies/${companyId}/finio-firm-name`, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] });
    },
  });

  const updateFinioFirmName = async (input: UpdateFinioFirmNameInput) => {
    return mutateAsync(input);
  };

  return { updateFinioFirmName, isLoading, error };
};
